import { useState, useCallback } from 'react';

export default function useModal(initialOpen = false) {
    const [open, setOpen] = useState(initialOpen);

    const handleOpen = useCallback(() => {
        setOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const toggle = useCallback(() => {
        setOpen(prev => !prev);
    }, []);

    return { open, handleOpen, handleClose, toggle, setOpen };
}
